import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./SpashScreen.css";
import AppLayout from "../../layout/AppLayout";
import { Context } from "../../utils/context";

const SplashOne = () => {
  const navigate = useNavigate();

  const { signin } = useContext(Context)

  useEffect(() => {
    const timer = setTimeout(() => {

      if (signin) {
        navigate("/home");
      } else {
        navigate("/login");
      }
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate, signin]);

  return (
    <div className="splash-page splash-one">
      <img
        src={"/assets/images/logo/logo.png"}
        alt="logo"
        className="logo_img"
      />

      <div className="brand_logo">

        <img
          src={"/assets/images/logo/money_king.png"}
          alt="logo"
          className="text_logo"
        />
      </div>

      <p className="tagline">
        Withdraw fast, Safe and Stable
      </p>
    </div>
  );
};

export default SplashOne;